(function () {
  'use strict';
  if (window.BPLMegaMenu) {
    window.BPLMegaMenu.refresh(document);
    return;
  }

  var ROOT = '[data-bpl-mega]';
  var states = new WeakMap();
  var pending = new Set();
  var rowPending = new Set();
  var serial = 0;
  var frame = 0;
  var rowFrame = 0;
  var seed = 'bpl-mega-' + Date.now().toString(36) + '-';

  function all(scope, selector) {
    return Array.prototype.slice.call(scope.querySelectorAll(selector));
  }

  function rootsIn(node) {
    if (!node || !node.querySelectorAll) return [];
    var roots = all(node, ROOT);
    if (node.matches && node.matches(ROOT)) roots.unshift(node);
    return roots;
  }

  function mobileParts(root) {
    if (!root.closest('#mobile_menu')) return null;
    var panel = root.closest('[data-meganav-target-container]');
    var item = panel && panel.parentElement;
    var trigger = item && item.firstElementChild;
    return trigger && trigger.tagName === 'A' ? { panel: panel, trigger: trigger } : null;
  }

  function desktopParent(root) {
    var item = root.closest('[data-nav-desktop-parent]');
    var manager = window.navigationDesktopManager;
    if (!item || !manager) return null;
    var navs = manager.desktopNavs || [];
    for (var i = 0; i < navs.length; i++) {
      var parents = navs[i].headerNavMenu ? navs[i].headerNavMenu.parents : [];
      for (var j = 0; j < parents.length; j++) {
        if (parents[j].menuItem === item) return parents[j];
      }
    }
    return null;
  }

  function mobileOpen(parts, open) {
    parts.panel.hidden = !open;
    parts.panel.style.display = open ? 'block' : 'none';
    parts.trigger.classList.toggle('active', open);
    parts.trigger.setAttribute('aria-expanded', String(open));
    if (open) rootsIn(parts.panel).forEach(queueRows);
  }

  function pixels(value) {
    return parseFloat(value) || 0;
  }

  function fitRows(root) {
    var state = states.get(root);
    if (!state) return;
    var panel = state.panels.find(function (candidate) { return candidate.dataset.bplPanel === state.active; });
    var grid = panel && panel.querySelector('.bpl-mega__tiles');
    if (!grid || !grid.getClientRects().length) return;
    var bounds = grid.getBoundingClientRect();
    if (bounds.width <= 0 || bounds.height <= 0) return;
    var style = window.getComputedStyle(grid);
    var borderTop = pixels(style.borderTopWidth);
    var rows = [];
    all(grid, '.bpl-mega__card').forEach(function (card) {
      var box = card.getBoundingClientRect();
      if (box.width <= 0 || box.height <= 0) return;
      var top = box.top - bounds.top + grid.scrollTop - borderTop;
      var bottom = top + box.height;
      var row = rows.find(function (candidate) { return Math.abs(candidate.top - top) < 1; });
      if (row) row.bottom = Math.max(row.bottom, bottom);
      else rows.push({ top: top, bottom: bottom });
    });
    if (!rows.length) return;
    rows.sort(function (a, b) { return a.top - b.top; });
    var limit = Math.max(1, Math.min(8, parseInt(root.dataset.visibleRows, 10) || 8));
    var last = rows[Math.min(limit, rows.length) - 1];
    var height = Math.ceil(last.bottom + pixels(style.paddingBottom) + borderTop + pixels(style.borderBottomWidth));
    var value = height + 'px';
    if (grid.style.getPropertyValue('--bpl-mega-rows-height') !== value) grid.style.setProperty('--bpl-mega-rows-height', value);
    if (bounds.top >= 0 && window.innerHeight > 0) {
      var reserve = 16 + pixels(style.marginBottom);
      var body = root.querySelector('.bpl-mega__body');
      if (body) reserve += pixels(window.getComputedStyle(body).paddingBottom);
      [panel.querySelector('.bpl-mega__links'), root.querySelector('.bpl-mega__footer')].forEach(function (after) {
        if (!after || !after.getClientRects().length) return;
        var afterStyle = window.getComputedStyle(after);
        reserve += after.getBoundingClientRect().height + pixels(afterStyle.marginTop) + pixels(afterStyle.marginBottom);
      });
      var available = Math.max(120, Math.floor(window.innerHeight - bounds.top - reserve));
      var ceiling = Math.min(available, window.innerHeight * 0.6);
      var whole = 0;
      rows.forEach(function (row) {
        var edge = Math.ceil(row.bottom + pixels(style.paddingBottom) + borderTop + pixels(style.borderBottomWidth));
        if (edge <= ceiling) whole = edge;
      });
      var viewportValue = (whole || available) + 'px';
      if (grid.style.getPropertyValue('--bpl-mega-viewport-height') !== viewportValue) grid.style.setProperty('--bpl-mega-viewport-height', viewportValue);
    }

    // Reveal an editor-selected or focused card after changing the height cap.
    // Using scrollIntoView here would also move the page and fixed header.
    var target = state.scrollTarget;
    if (!target || !grid.contains(target)) {
      var focused = document.activeElement;
      var focusedCard = focused && focused.closest ? focused.closest('.bpl-mega__card') : null;
      target = focusedCard && grid.contains(focusedCard) ? focusedCard : null;
    }
    if (target && grid.contains(target)) {
      var targetBounds = target.getBoundingClientRect();
      var viewport = grid.getBoundingClientRect();
      var topEdge = viewport.top + borderTop + pixels(style.paddingTop);
      var bottomEdge = viewport.top + borderTop + grid.clientHeight - pixels(style.paddingBottom);
      var delta = 0;
      if (targetBounds.height > bottomEdge - topEdge || targetBounds.top < topEdge) delta = targetBounds.top - topEdge;
      else if (targetBounds.bottom > bottomEdge) delta = targetBounds.bottom - bottomEdge;
      if (delta) grid.scrollTop = Math.max(0, grid.scrollTop + delta);
      state.scrollTarget = null;
    }
  }

  function queueRows(root) {
    if (!root || !states.has(root)) return;
    rowPending.add(root);
    if (rowFrame) return;
    rowFrame = window.requestAnimationFrame(function () {
      rowFrame = 0;
      rowPending.forEach(function (candidate) { if (candidate.isConnected) fitRows(candidate); });
      rowPending.clear();
    });
  }

  function refreshRows() {
    all(document, ROOT).forEach(queueRows);
  }

  function selectGroup(root, key) {
    var state = states.get(root);
    if (!state || !state.keys.length) return;
    if (state.keys.indexOf(key) === -1) key = state.keys[0];
    state.active = key;
    state.buttons.forEach(function (button) {
      var selected = button.dataset.bplGroup === key;
      button.setAttribute('aria-pressed', String(selected));
      button.classList.toggle('is-active', selected);
    });
    state.panels.forEach(function (panel) {
      panel.hidden = panel.dataset.bplPanel !== key;
    });
    if (state.select) state.select.value = key;
    root.classList.add('is-ready');
    queueRows(root);
  }

  function uniqueIds(root, prefix) {
    var ids = Object.create(null);
    var nodes = [root].concat(all(root, '[id]'));
    nodes.forEach(function (node, index) {
      var old = node.id;
      var next = prefix + '-' + index;
      if (old && !ids[old]) ids[old] = next;
      node.id = next;
    });
    [root].concat(all(root, '[for],[aria-controls],[aria-labelledby],[aria-describedby],[aria-owns],[aria-activedescendant],[href^="#"]')).forEach(function (node) {
      ['for', 'aria-controls', 'aria-labelledby', 'aria-describedby', 'aria-owns', 'aria-activedescendant'].forEach(function (attribute) {
        var value = node.getAttribute(attribute);
        if (value) node.setAttribute(attribute, value.split(/\s+/).map(function (id) { return ids[id] || id; }).join(' '));
      });
      var href = node.getAttribute('href');
      if (href && href.charAt(0) === '#' && ids[href.slice(1)]) node.setAttribute('href', '#' + ids[href.slice(1)]);
    });
  }

  function mount(root) {
    if (states.has(root)) return;
    var prefix = seed + (++serial);
    uniqueIds(root, prefix);
    var state = {
      buttons: all(root, '[data-bpl-group]'),
      panels: all(root, '[data-bpl-panel]'),
      select: root.querySelector('[data-bpl-group-select]'),
      keys: [],
      active: '',
      scrollTarget: null
    };
    state.panels.forEach(function (panel, index) {
      var key = panel.dataset.bplPanel;
      state.keys.push(key);
      panel.id = panel.id || prefix + '-panel-' + index;
      var button = state.buttons.find(function (candidate) { return candidate.dataset.bplGroup === key; });
      if (button) {
        button.id = button.id || prefix + '-group-' + index;
        button.setAttribute('aria-controls', panel.id);
        panel.setAttribute('aria-labelledby', button.id);
      }
    });
    if (state.select) {
      state.select.id = state.select.id || prefix + '-select';
      var label = root.querySelector('[data-bpl-select-label]');
      if (label) label.setAttribute('for', state.select.id);
    }
    var mobile = mobileParts(root);
    if (mobile) {
      mobile.panel.id = prefix + '-mobile';
      mobile.trigger.setAttribute('aria-controls', mobile.panel.id);
      mobile.trigger.setAttribute('role', 'button');
      mobileOpen(mobile, mobile.panel.style.display === 'block');
    } else {
      var desktop = root.closest('[data-nav-desktop-parent]');
      if (desktop) {
        var submenu = desktop.querySelector('[data-nav-desktop-submenu]');
        var trigger = desktop.querySelector('[data-nav-desktop-link]');
        if (submenu && trigger) {
          submenu.id = prefix + '-desktop';
          trigger.setAttribute('aria-controls', submenu.id);
        }
      }
    }
    states.set(root, state);
    selectGroup(root, root.dataset.initialGroup);
  }

  function queue(node) {
    rootsIn(node).forEach(function (root) { if (!states.has(root)) pending.add(root); });
    if (!pending.size || frame) return;
    frame = window.requestAnimationFrame(function () {
      frame = 0;
      pending.forEach(function (root) { if (root.isConnected) mount(root); });
      pending.clear();
    });
  }

  function ownTrigger(target) {
    var trigger = target.closest('[data-nav-desktop-link], #mobile_menu > li > a');
    if (!trigger) return null;
    var item = trigger.closest('[data-nav-desktop-parent]') || trigger.parentElement;
    var root = item && item.querySelector(ROOT);
    if (!root) return null;
    mount(root);
    var mobile = mobileParts(root);
    if (mobile && mobile.trigger === trigger) return { root: root, mobile: mobile };
    if (trigger.matches('[data-nav-desktop-link]')) {
      var parent = desktopParent(root);
      if (parent && parent.menuLink === trigger) return { root: root, desktop: parent };
    }
    return null;
  }

  function closeRoot(root) {
    var mobile = mobileParts(root);
    if (mobile) {
      var drawer = window.mobileMenuDrawer;
      if (drawer && drawer.close) {
        drawer.close();
        if (drawer.trigger) drawer.trigger.focus();
      } else {
        mobileOpen(mobile, false);
        mobile.trigger.focus();
      }
      return;
    }
    var parent = desktopParent(root);
    if (parent) {
      // Theme editor selection can lock the parent; an explicit close releases it.
      if (window.Shopify && window.Shopify.designMode && window.meganavManager) window.meganavManager.deselect();
      parent.close();
      parent.menuLink.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var trigger = ownTrigger(target);
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      if (trigger.mobile) mobileOpen(trigger.mobile, trigger.mobile.trigger.getAttribute('aria-expanded') !== 'true');
      else if (trigger.desktop.detailsItem.open) closeRoot(trigger.root);
      else {
        trigger.desktop.open();
        queueRows(trigger.root);
      }
      return;
    }
    var root = target.closest(ROOT);
    if (root) {
      mount(root);
      var button = target.closest('[data-bpl-group], [data-bpl-close]');
      if (!button || button.disabled) return;
      event.preventDefault();
      event.stopPropagation();
      if (button.hasAttribute('data-bpl-close')) closeRoot(root);
      else selectGroup(root, button.dataset.bplGroup);
      return;
    }
    var drawer = window.mobileMenuDrawer;
    if (drawer && drawer.el && drawer.el.open && !drawer.el.contains(target)) {
      var active = drawer.el.querySelector(ROOT);
      var parts = active && mobileParts(active);
      if (parts && parts.trigger.getAttribute('aria-expanded') === 'true') drawer.close();
    }
  }, true);

  // The legacy desktop parent also listens to touchend. Let its following click
  // perform the single toggle, rather than opening once and immediately closing.
  document.addEventListener('touchend', function (event) {
    if (!event.target || !event.target.closest) return;
    var trigger = ownTrigger(event.target);
    var control = event.target.closest('[data-bpl-group], [data-bpl-close]');
    if ((trigger && trigger.desktop) || (control && control.closest(ROOT))) event.stopPropagation();
  }, true);

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.matches || !select.matches('[data-bpl-group-select]')) return;
    var root = select.closest(ROOT);
    if (!root) return;
    mount(root);
    selectGroup(root, select.value);
  }, true);

  document.addEventListener('keydown', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var root = target.closest(ROOT);
    var trigger = ownTrigger(target);
    if (trigger && trigger.mobile && (event.key === ' ' || event.key === 'Spacebar')) {
      event.preventDefault();
      event.stopPropagation();
      mobileOpen(trigger.mobile, trigger.mobile.trigger.getAttribute('aria-expanded') !== 'true');
      return;
    }
    if (!root && trigger) root = trigger.root;
    if (!root) return;
    mount(root);
    if (event.key === 'Escape' && mobileParts(root) && target.tagName !== 'SELECT') {
      event.preventDefault();
      event.stopPropagation();
      closeRoot(root);
      return;
    }
    var button = target.closest('[data-bpl-group]');
    if (!button) return;
    var state = states.get(root);
    var buttons = state.buttons.filter(function (candidate) { return !candidate.disabled; });
    var index = buttons.indexOf(button);
    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') index = (index + 1) % buttons.length;
    else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') index = (index + buttons.length - 1) % buttons.length;
    else if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = buttons.length - 1;
    else return;
    event.preventDefault();
    event.stopPropagation();
    selectGroup(root, buttons[index].dataset.bplGroup);
    buttons[index].focus();
  }, true);

  function editorSelect(event) {
    var detail = event.detail || {};
    var section = detail.sectionId;
    if (!section && event.target && event.target.closest) {
      var source = event.target.closest('.shopify-section');
      if (source) section = source.id.replace(/^shopify-section-/, '');
    }
    if (!section) return;
    window.requestAnimationFrame(function () {
      all(document, ROOT).forEach(function (root) {
        if (root.dataset.sectionId !== section) return;
        mount(root);
        if (detail.blockId) {
          var block = all(root, '[data-bpl-block-id], [data-bpl-group-block-id]').find(function (node) {
            return node.dataset.bplBlockId === detail.blockId || node.dataset.bplGroupBlockId === detail.blockId;
          });
          if (!block) return;
          var panel = block.closest('[data-bpl-panel]');
          selectGroup(root, block.dataset.bplGroup || block.dataset.bplGroupKey || (panel && panel.dataset.bplPanel));
          var card = block.closest('.bpl-mega__card');
          if (card) states.get(root).scrollTarget = card;
        }
        var mobile = mobileParts(root);
        if (mobile) {
          var drawer = window.mobileMenuDrawer;
          if (drawer && drawer.trigger && drawer.trigger.getClientRects().length) {
            drawer.open();
            mobileOpen(mobile, true);
          }
        } else {
          var parent = desktopParent(root);
          if (parent && parent.menuItem.getClientRects().length) parent.forceOpen();
        }
        queueRows(root);
      });
    });
  }

  document.addEventListener('shopify:section:select', editorSelect);
  document.addEventListener('shopify:block:select', editorSelect);
  document.addEventListener('shopify:section:load', function (event) { queue(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    rootsIn(event.target).forEach(function (root) {
      pending.delete(root);
      rowPending.delete(root);
      states.delete(root);
    });
  });

  document.addEventListener('toggle', function (event) {
    if (event.target && event.target.open) rootsIn(event.target).forEach(queueRows);
  }, true);
  document.addEventListener('load', function (event) {
    if (event.target && event.target.closest) queueRows(event.target.closest(ROOT));
  }, true);
  document.addEventListener('focusin', function (event) {
    if (!event.target || !event.target.closest) return;
    var root = event.target.closest(ROOT);
    if (!root) return;
    mount(root);
    var card = event.target.closest('.bpl-mega__card');
    if (card && root.contains(card)) states.get(root).scrollTarget = card;
    queueRows(root);
  }, true);
  window.addEventListener('resize', refreshRows);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(refreshRows);
  if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', refreshRows);

  function start() {
    queue(document);
    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        Array.prototype.forEach.call(record.addedNodes, queue);
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
  window.BPLMegaMenu = { version: 2, refresh: function (node) { queue(node); rootsIn(node).forEach(queueRows); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
